import { useState } from "react";
import { useTranslation } from "react-i18next"
const Contact = () => {
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setError(null);

    try {
      const res = await fetch('https://mydatacheck.site/api/send-mail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ nom, email, text }),
      });
       setLoading(true);
      if (!res.ok) throw new Error('Erreur lors de l’envoi');

      setSuccess(true);
      setNom('');
      setEmail('');
      setText('');
    } catch (err) {
      setError(err.message);
    }

    
  };
   const {t}= useTranslation();

  return (
    
    <section className="min-h-[100vh]">
      <div className="max-w-3xl mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold text-center mb-10 text-[#42AB3F]">{t("contactTitle")}</h1>
        <form onSubmit={handleSubmit} className="space-y-6 bg-white dark:bg-white p-8 rounded-2xl shadow">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300   poppins">{t("contactName")}</label>
            <input type="text" value={nom} onChange={(e) => setNom(e.target.value)} className="w-full mt-1 p-3 border rounded-lg bg-gray-50 dark:bg-[#706F6F] text-gray-800 dark:text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{t("contactEmail")}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 p-3 border rounded-lg bg-gray-50 dark:bg-[#706F6F] text-gray-800 dark:text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{t("contactMessage")}</label>
            <textarea rows="5" value={text} onChange={(e) => setText(e.target.value)} className="w-full mt-1 p-3 border rounded-lg bg-gray-50 dark:bg-[#706F6F] text-gray-800 dark:text-white" />
          </div>
          <button type="submit" disabled={loading} className="bg-[#DA6E2f] hover:bg-[#33241c]   text-white font-semibold px-6 py-3 rounded-xl">
            {loading ? t("contactsending") : t("contactsendin")}
          </button>
        </form>
        {success && <p className="mt-4 text-green-600">✅ {t("contactsend")}</p>}
        {error && <p className="mt-4 text-red-600">❌ {error}</p>}
      </div>
    </section>
  );
};

export default Contact;
